"use strict";

angular.module('app.shared.selectWithDisabledOption.selectWithDisabledOptionDirective', [])
    .directive('selectWithDisabledOption', [
        function () {
            return {
                restrict: 'A',
                link: function (scope, elm) {
                    angular.forEach(elm.find('option'), function (option) {
                        if (option.selected && option.disabled) {
                            elm.addClass('disabled-selected');
                            elm.on('change', function () {
                                elm.removeClass('disabled-selected');
                            });
                        }
                    });
                }
            }
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/selectWithDisabledOption/selectWithDisabledOptionDirective.js